// QA harness bootstrap (cards um8gehdw, nJFP0atO).
//
// A `?qaCustomToken=` param is how qa/screenshot-demo-history.mjs hands a
// Playwright-driven page the demo principal's session, minted out-of-band by
// qa/mint-demo-session.mjs. The token exchanges for a long-lived refresh
// token, so it must never reach browser history, a screenshot of the chrome,
// or a third party.
//
// ORDER IS THE CONTRACT: the token leaves the URL and the history entry
// SYNCHRONOUSLY, and only then does analytics start. main.ts used to call
// initAnalytics() first and strip second; that was safe only because
// posthog-js happened to defer its first pageview by a tick. Any analytics
// option that reads location.href at init would have shipped the token.
//
// Plain dependency-free ESM (types in qa-token.d.mts) so the CI `scripts` job
// can run scripts/test/qa-token-before-analytics.test.mjs with bare `node
// --test`, no install and no transpiler.

export const QA_TOKEN_PARAM = 'qaCustomToken';

/**
 * Remove every `qaCustomToken` param from the current URL and history entry,
 * synchronously. Returns the token, or null when absent or empty. Calls
 * replaceState only when there was something to strip.
 */
export function takeQaToken(loc, hist) {
  const params = new URLSearchParams(loc.search);
  if (!params.has(QA_TOKEN_PARAM)) return null;
  const token = params.get(QA_TOKEN_PARAM);
  params.delete(QA_TOKEN_PARAM);
  const rest = params.toString();
  hist.replaceState(null, '', loc.pathname + (rest ? `?${rest}` : '') + loc.hash);
  return token || null;
}

/**
 * Strip the QA token, THEN start analytics, then (if there was a token) sign
 * in with it. A failed QA sign-in is reported through onSignInError and never
 * thrown: the normal sign-in screen still renders.
 */
export async function bootQaSessionAndAnalytics({
  location: loc,
  history: hist,
  initAnalytics,
  signInWithQaToken,
  onSignInError,
}) {
  const token = takeQaToken(loc, hist);
  initAnalytics();
  if (!token) return;
  try {
    await signInWithQaToken(token);
  } catch (e) {
    onSignInError(e);
  }
}
